import React from "react";
import { useNavigate } from "react-router-dom";

// The back arrow on the standalone leaderboard and the standalone league
// profile.
//
// Client, League Play Dev Request: "The back arrow must return the user to the
// screen they came from." That is HISTORY, not a fixed destination — the same
// leaderboard is reached from My Leagues' Completed tab, from League Play home's
// My Leagues section and from a live league's View Leaderboard CTA, and a
// hardcoded `to` would send two of those three somewhere they have never been.
//
// `fallback` only applies when there is no history to go back to, which in
// practice means the URL was opened cold — a shared link, or a new tab.
const BackArrowButton = ({ fallback = "/contest", className = "" }) => {
  const navigate = useNavigate();

  const goBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };

  return (
    <button
      type="button"
      onClick={goBack}
      aria-label="Go back"
      className={`-ml-2 mb-1 flex h-10 w-10 items-center justify-center rounded-full text-[#0F4146] transition-colors hover:bg-[#F1F5F5] ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6"
      >
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
    </button>
  );
};

export default BackArrowButton;
